/* NCMPRBL — Clarity Collection : motion layer
   Signature moment : hero portrait wall (hover / auto-advance, six colorways)
   Second moment    : pinned scroll-scrubbed spectrum, field tone morphing per frame
   Supporting       : split-text mask reveals, clip wipes, photo drift band,
                      small parallax pairs, odometer counters, sticky dock
   All motion is transform / opacity / colour only and respects prefers-reduced-motion. */

(function () {
  'use strict';

  /* ---- section lifecycle plumbing (added 2026-08-12) ---------------------
     Shopify's theme editor destroys and re-renders a section's DOM on every
     edit without reloading the page, and it never re-runs a deferred script.
     Without this, one edit left the page inert and leaked a window listener
     per edit. init() holds all state, destroy() releases it, and GEN
     invalidates any rAF callback still queued from a previous generation. */
  var CLEANUP = [], GEN = 0;
  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    CLEANUP.push(function () { target.removeEventListener(type, fn, opts); });
  }
  function tracked(observer) {
    CLEANUP.push(function () { observer.disconnect(); });
    return observer;
  }
  function destroy() {
    GEN++;
    for (var i = 0; i < CLEANUP.length; i++) { try { CLEANUP[i](); } catch (e) {} }
    CLEANUP.length = 0;
  }

  function init() {
    var MY_GEN = ++GEN;
    function alive() { return MY_GEN === GEN; }

    /* ---------- live pricing (injected) ----------------------------------------
       Prices come from the #lp-prices JSON block, which the Liquid section renders
       directly from the product records. This file holds no authoritative price;
       the strings in FRAMES are a fallback for when the block is absent. */
    var LP_PRICES = (function () {
      try { return JSON.parse(document.getElementById('lp-prices').textContent); }
      catch (e) { return {}; }
    })();
    function lpRec(url) {
      var m = /\/products\/([^\/?#]+)/.exec(url || '');
      return (m && LP_PRICES[m[1]]) || null;
    }
    function lpPrice(url, fallback) {
      var r = lpRec(url);
      if (!r || !r.money) return fallback || '';
      return /USD/.test(fallback || '') ? r.money + ' USD' : r.money;
    }
    function lpCompare(url, fallback) {
      var r = lpRec(url);
      return r ? r.compare : (fallback || null);
    }
    /* price + optional compare-at strikethrough, as one expression */
    function lpHtml(f) {
      var was = lpCompare(f.url, f.was);
      return lpPrice(f.url, f.price) + (was ? ' <s>' + was + '</s>' : '');
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- the six colorways, in the order the collection is merchandised --- */
    var FRAMES = [
      {
        idx: 'Focused — 46 MM',
        name: 'Obsidian Black',
        desc: 'The reference point. Full-rim geometry in obsidian black acetate, drawn to hold its line without asking for the room.',
        price: '$285 USD', was: null,
        img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/focused_1-1.png?width=1400',
        url: 'https://ncmprblife.com/products/focused-46mm-geometric-eyeglasses-obsidian-black',
        material: 'Premium cellulose acetate',
        accent: '#14110F', field: '#E9E8E6', fg: '#161514'
      },
      {
        idx: 'Haze — 46 MM',
        name: 'Smoked Violet',
        desc: 'Haze invites the mystery of minimalism. A subtle tonal variation designed to shift with light, environment, and movement.',
        price: '$295 USD', was: null,
        img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/CherryShot-HAZE-1758070669542.png?width=1400',
        url: 'https://ncmprblife.com/products/haze-46mm-geometric-eyeglasses-smoked-violet',
        material: 'Premium cellulose acetate',
        accent: '#4A2F4E', field: '#EDE7EE', fg: '#20161F'
      },
      {
        idx: 'Oakwood — 46 MM',
        name: 'Orange Sandalwood',
        desc: 'Handmade acetate for a distinctive full-rim everyday frame. The warm sandalwood tone brings a considered accent to a minimal wardrobe.',
        price: '$295 USD', was: '$385',
        img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/oakwood_1080x1080_0e76bf6f-e222-4abb-899b-14680b2af67b.jpg?width=1400',
        url: 'https://ncmprblife.com/products/oakwood-46mm-geometric-eyeglasses-orange-sandalwood',
        material: 'Handmade cellulose acetate',
        accent: '#8E4A22', field: '#F2E7DC', fg: '#241710'
      },
      {
        idx: 'Dusk — 46 MM',
        name: 'Brown Tortoise',
        desc: 'A study in proportion and presence. A geometric frame refined into a modern essential — its form is intentional, not expressive.',
        price: '$315 USD', was: '$375',
        img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/dusk_1080x1080_1_front.jpg?width=1400',
        url: 'https://ncmprblife.com/products/dusk-46mm-geometric-eyeglasses-brown-tortoise',
        material: 'Premium cellulose acetate',
        accent: '#5E2F17', field: '#EFE4DA', fg: '#221610'
      },
      {
        idx: 'Clearview — 46 MM',
        name: 'Transparent / Rich Yellow Gold',
        desc: 'Structured geometric fit that maintains form, rendered almost invisible. Transparent acetate warmed with rich yellow gold detail.',
        price: '$295 USD', was: null,
        img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/clearview_spring_10801x1080_7405d9d9-6d9d-4591-a004-eb51f9673465.jpg?width=1400',
        url: 'https://ncmprblife.com/products/clearview-46mm-geometric-eyeglasses-clear',
        material: 'Premium cellulose acetate',
        accent: '#A98A3C', field: '#F1EEE6', fg: '#241F14'
      },
      {
        idx: 'Manifest — 46 MM',
        name: 'Deep Evergreen Teal',
        desc: 'The quietest colour in the collection and the loudest in person. Deep evergreen teal acetate over clear CR-39.',
        price: '$229 USD', was: '$365',
        img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/manifest_1-1.jpg?width=1400',
        url: 'https://ncmprblife.com/products/manifest-46mm-geometric-eyeglasses-deep-evergreen-teal',
        material: 'Premium cellulose acetate',
        accent: '#14403E', field: '#E4EBEA', fg: '#12211F'
      }
    ];

    /* ---------- entrance reveals (scroll-driven, no IO race with image load) --- */
    var revealEls = [].slice.call(document.querySelectorAll('.rv, .clip, .lines'));
    function runReveals() {
      var vh = window.innerHeight;
      for (var i = revealEls.length - 1; i >= 0; i--) {
        var r = revealEls[i].getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) { revealEls[i].classList.add('in'); revealEls.splice(i, 1); }
      }
    }

    /* ---------- odometer counters ---------- */
    var cio = tracked(new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target, target = parseFloat(el.dataset.count), isInt = el.dataset.int === '1';
        if (reduce) { el.textContent = isInt ? target : target.toFixed(2); return; }
        var t0 = null, dur = 1400;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), e2 = 1 - Math.pow(1 - p, 3), v = target * e2;
          el.textContent = isInt ? Math.round(v).toLocaleString() : v.toFixed(2);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 }));
    document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

    /* ---------- scrub-fill manifesto sentence ---------- */
    var scrub = document.querySelector('[data-scrub]');
    var scrubWords = [];
    if (scrub) {
      var words = scrub.textContent.trim().split(/\s+/);
      scrub.textContent = '';
      words.forEach(function (w, i) {
        var b = document.createElement('b');
        b.textContent = w;
        scrub.appendChild(b);
        if (i < words.length - 1) scrub.appendChild(document.createTextNode(' '));
        scrubWords.push(b);
      });
    }

    /* ======================================================================
       SIGNATURE 1 — hero portrait wall
       Six columns, one per colorway. Hover (or tap) expands a column and
       lifts its grade; with no pointer on it, it advances itself every 4.2s.
       ====================================================================== */
    var cols = [].slice.call(document.querySelectorAll('.wall__col'));
    var swatches = [].slice.call(document.querySelectorAll('[data-sw]'));
    var wallActive = -1, wallTimer = null, wallHeld = false;

    function setWall(i) {
      if (i === wallActive) return;
      wallActive = i;
      cols.forEach(function (c, n) { c.classList.toggle('on', n === i); });
      swatches.forEach(function (s, n) {
        s.classList.toggle('on', n === i);
        s.setAttribute('aria-pressed', n === i ? 'true' : 'false');
      });
    }
    function wallCycle() {
      if (wallHeld) return;
      setWall((wallActive + 1) % Math.max(cols.length, 1));
    }
    if (cols.length) {
      setWall(0);
      if (!reduce) wallTimer = setInterval(wallCycle, 4200);
      cols.forEach(function (c, n) {
        on(c, 'pointerenter', function () { wallHeld = true; setWall(n); });
        on(c, 'pointerleave', function () { wallHeld = false; });
        on(c, 'focusin', function () { wallHeld = true; setWall(n); });
      });
      swatches.forEach(function (s, n) {
        s.addEventListener('click', function () { wallHeld = true; setWall(n); setTimeout(function () { wallHeld = false; }, 6000); });
        on(s, 'pointerenter', function () { wallHeld = true; setWall(n); });
        on(s, 'pointerleave', function () { wallHeld = false; });
      });
      var heroEl = document.querySelector('.hero');
      if (heroEl && wallTimer) {
        var hio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting && !wallTimer) wallTimer = setInterval(wallCycle, 4200);
            else if (!e.isIntersecting && wallTimer) { clearInterval(wallTimer); wallTimer = null; }
          });
        }, { threshold: 0.05 });
        hio.observe(heroEl);
      }
    }

    /* ======================================================================
       SIGNATURE 2 — pinned spectrum, field tone morphing per colorway
       ====================================================================== */
    var specSec = document.getElementById('spectrum');
    var specPin = document.getElementById('specPin');
    var stages = [].slice.call(document.querySelectorAll('[data-stage]'));
    var panes = [].slice.call(document.querySelectorAll('[data-pane]'));
    var rail = [].slice.call(document.querySelectorAll('[data-rail]'));
    var chip = document.querySelector('[data-chip]');
    var chipTxt = document.querySelector('[data-chip-txt]');
    var mIdx = document.querySelector('[data-m-idx]'), mName = document.querySelector('[data-m-name]'),
        mDesc = document.querySelector('[data-m-desc]'), mPrice = document.querySelector('[data-m-price]');
    var dockImg = document.getElementById('dockImg'), dockName = document.getElementById('dockName'),
        dockPrice = document.getElementById('dockPrice'), dockCta = document.getElementById('dockCta'),
        dock = document.getElementById('dock');
    var specActive = -1;

    function setSpec(i) {
      if (i === specActive) return;
      specActive = i;
      var f = FRAMES[i];
      stages.forEach(function (el, n) { el.classList.toggle('on', n === i); });
      panes.forEach(function (el) { el.classList.toggle('on', +el.dataset.pane === i); });
      rail.forEach(function (el, n) { el.classList.toggle('on', n === i); });
      if (specPin) { specPin.style.backgroundColor = f.field; specPin.style.color = f.fg; }
      if (chip) chip.style.setProperty('--chip', f.accent);
      if (chipTxt) chipTxt.textContent = f.name;
      if (mIdx) { mIdx.textContent = f.idx; mName.textContent = f.name; mDesc.textContent = f.desc; }
      if (mPrice) mPrice.innerHTML = lpHtml(f);
      if (dockImg) {
        dockImg.src = f.img;
        dockName.textContent = f.idx.replace(' — 46 MM', '') + ' — ' + f.name;
        dockPrice.textContent = lpPrice(f.url, f.price);
        dockCta.href = f.url;
      }
    }
    setSpec(0);

    rail.forEach(function (d, i) {
      on(d, 'click', function () {
        if (!specSec) return;
        var top = specSec.offsetTop + (specSec.offsetHeight - window.innerHeight) * ((i + 0.5) / FRAMES.length);
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* ---------- drift band + parallax + scrub fill + dock (single rAF) ---------- */
    var drifts = [].slice.call(document.querySelectorAll('[data-drift]'));
    var paras = [].slice.call(document.querySelectorAll('[data-para]'));
    var ticking = false;

    function frame() {
      if (!alive()) return;
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var vh = window.innerHeight;

      runReveals();

      if (!reduce) {
        drifts.forEach(function (row) {
          var r = row.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var prog = (vh - r.top) / (vh + r.height);
          var dir = +row.dataset.drift;
          var span = row.scrollWidth / 2;
          var shift = (prog - 0.5) * span * 0.5 * dir;
          row.style.transform = 'translateX(' + (dir < 0 ? -span * 0.25 - shift : -span * 0.25 + shift) + 'px)';
        });
        paras.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var prog = (vh - r.top) / (vh + r.height) - 0.5;
          el.style.transform = 'translateY(' + (prog * +el.dataset.para) + 'px)';
        });
        if (scrubWords.length) {
          var sr = scrub.getBoundingClientRect();
          var sp = (vh * 0.86 - sr.top) / (sr.height + vh * 0.24);
          sp = Math.max(0, Math.min(1, sp));
          var lit = Math.round(sp * scrubWords.length);
          scrubWords.forEach(function (w, i) { w.classList.toggle('lit', i < lit); });
        }
      } else if (scrubWords.length) {
        scrubWords.forEach(function (w) { w.classList.add('lit'); });
      }

      if (specSec) {
        var sr2 = specSec.getBoundingClientRect();
        var total = specSec.offsetHeight - vh;
        var prog2 = Math.max(0, Math.min(0.9999, -sr2.top / total));
        setSpec(Math.floor(prog2 * FRAMES.length));
      }

      if (dock) {
        var col = document.getElementById('collection');
        var closeSec = document.querySelector('.close');
        var show = col && (y + vh) > col.offsetTop + 200 && (!closeSec || y + vh < closeSec.offsetTop + 120);
        dock.classList.toggle('on', !!show);
      }
    }

    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });
    frame();

    /* ---------- FAQ: one open at a time ---------- */
    var dets = [].slice.call(document.querySelectorAll('.faq details'));
    dets.forEach(function (d) {
      on(d, 'toggle', function () {
        if (d.open) dets.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });

    /* ---------- magnetic CTAs (desktop pointers only) ---------- */
    if (!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.querySelectorAll('.btn').forEach(function (b) {
        on(b, 'pointermove', function (e) {
          var r = b.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
          var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
          b.style.transform = 'translate(' + (dx * 8).toFixed(2) + 'px,' + (dy * 6).toFixed(2) + 'px)';
        });
        on(b, 'pointerleave', function () {
          b.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)';
          b.style.transform = '';
          setTimeout(function () { b.style.transition = ''; }, 520);
        });
      });
    }
  }

  function boot() {
    destroy();
    if (document.querySelector('.clarity-lp')) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.querySelector && (t.querySelector('.clarity-lp') || t.matches && t.matches('.clarity-lp'))) boot();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    if (t && t.querySelector && (t.querySelector('.clarity-lp') || t.matches && t.matches('.clarity-lp'))) destroy();
  });
})();

/* Measure whatever sits above this section (store header/announcement bar) so the
   hero fills exactly one screen below it instead of pushing its copy off-screen.
   Re-measured on section load so a customizer edit does not leave a stale --hdr. */
(function(){
  var CLEAN=[], timers=[];
  function bind(){
    unbind();
    var lp=document.querySelector('.clarity-lp');
    if(!lp) return;
    function setH(){
      if(window.scrollY>4) return;
      var t=lp.getBoundingClientRect().top;
      if(!isFinite(t)) t=0;
      t=Math.max(0,Math.min(280,Math.round(t)));
      lp.style.setProperty('--hdr', t+'px');
    }
    setH();
    window.addEventListener('resize',setH,{passive:true});
    window.addEventListener('load',setH);
    CLEAN.push(function(){
      window.removeEventListener('resize',setH,{passive:true});
      window.removeEventListener('load',setH);
    });
    timers.push(setTimeout(setH,400), setTimeout(setH,1200));
  }
  function unbind(){
    for(var i=0;i<CLEAN.length;i++){ try{CLEAN[i]();}catch(e){} }
    CLEAN.length=0;
    for(var j=0;j<timers.length;j++) clearTimeout(timers[j]);
    timers.length=0;
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bind,{once:true});
  else bind();
  document.addEventListener('shopify:section:load',function(e){
    var t=e.target;
    if(t&&t.querySelector&&t.querySelector('.clarity-lp')) bind();
  });
  document.addEventListener('shopify:section:unload',function(){ unbind(); });
})();
